/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Pol_Badge_GrayInputs */

const en_pol_badge_gray = /** @type {(inputs: Pol_Badge_GrayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vendor policy: gray · checked ${i?.date}`)
};

const id_pol_badge_gray = /** @type {(inputs: Pol_Badge_GrayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`kebijakan vendor: abu-abu · dicek ${i?.date}`)
};

/**
* | output |
* | --- |
* | "vendor policy: gray · checked {date}" |
*
* @param {Pol_Badge_GrayInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_badge_gray = /** @type {((inputs: Pol_Badge_GrayInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Badge_GrayInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_badge_gray(inputs)
	return en_pol_badge_gray(inputs)
});